import React, { Component } from 'react';
import { connect } from 'react-redux';
import { EventsActions, MessagesActions } from '../../../../actions';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faHeart} from '@fortawesome/fontawesome-free-solid';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import 'moment/locale/he';
import { BoxTitle, Box } from '../../../PageTemplate';
import { ValidateDate } from '../../../../helper';
import 'react-datepicker/dist/react-datepicker.css';
import './date.scss';

const {REACT_APP_EVENT_MAX_DURATION_TIME_IN_HOURS, REACT_APP_DATE_PICKER_TIME_INTERVALSE} = process.env;

moment.locale('he');

class Date extends Component {
    constructor(props) {
        super(props);

        const now = moment();
        this.state = {
            eventID: null,
            eventData: {},
            error: {
                date: {
                    start: false,
                    end: false
                }
            },
            eventStarted: false,
            eventFinised: false,
            dateRange: {
                start: {
                    minDate: now,
                    maxDate: moment().add(1, 'year'),
                    minTime: moment().hours(now.hours()).minutes(now.minutes()),
                    maxTime: moment().hours(23).minutes(59)
                },
                end: {
                    minDate: null,
                    maxDate: null,
                    minTime: null,
                    maxTime: null
                }
            }
        }

        this.handleDateChange = this.handleDateChange.bind(this);
        this.updateStartDateRange = this.updateStartDateRange.bind(this);
        this.updateEndDateRange = this.updateEndDateRange.bind(this);        
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        const {eventFinised, eventStarted} = props;
        const events = props.events.list;
        const eventID = props.events.currentEventID;
        const newState = {};
        const newStateData = {};

        if(!events || !events[eventID]) return null;
        
        if(eventID && eventID !== state.eventID) newState.eventID = eventID; 
        if(eventFinised && eventFinised !== state.eventFinised) newState.eventFinised = eventFinised;
        if(eventStarted && eventStarted !== state.eventStarted) newState.eventStarted = eventStarted;
        
        const {date, demo} = events[eventID];
        newStateData.demo = demo;

        if(date) {
            for(let p in date) {
                if(!newStateData.date) newStateData.date = {};
                newStateData.date[p] = date[p];
            }
        }

        if(Object.keys(newStateData).length > 0) newState.eventData = newStateData;
        if(Object.keys(newState).length > 0) return newState;

        return null;
    }

    validation() {
        const {dispatch} = this.props;
        const {eventData} = this.state;
        const maxHours = REACT_APP_EVENT_MAX_DURATION_TIME_IN_HOURS;
        const tz = eventData.date.timeZone;
        const start = eventData.date.start;
        const end = eventData.date.end;

        const invalidStartDate = moment(start) != null && ValidateDate.earlierFromNow(start, tz) && !this.state.eventStarted;
        const invalidEndDate = moment(start) != null && moment(end) != null && ValidateDate.houresRangeLimitExceeded(start, end, maxHours, 0, tz);

        if(invalidStartDate) {
            dispatch(MessagesActions.pushError('לא ניתן לבחוז זמן התחלה הקודם לעכשיו'));
        }

        if(invalidEndDate) {
            dispatch(MessagesActions.pushError(`זמו סיום האירוע לא תקין: הזמן המקסימלי לאירוע הוא ${maxHours} שעות`));
        }

        var err = {
            date: {
                start: invalidStartDate,
                end: invalidEndDate
            }
        }

        this.setState({error: {...this.state.error, ...err}});

        const hasError = JSON.stringify(err);
        return hasError.indexOf(true) === -1;
    }

    updateStartDateRange(date) {
        const now = moment();
        const range = {...this.state.dateRange};

        range.start.minTime = moment().hours(now.hours()).minutes(now.minutes());

        // if date day is not currnet day -> start time from 0:00 (and not from current time)
        if(date && moment(date) !== null) {
            if(moment(date).date() !== moment().date()) {
                range.start.minTime = moment().hours(0).minute(0);
            }
        }

        this.setState({dateRange: range});
        this.updateEndDateRange();
    }

    updateEndDateRange(date) {
        const { start, timeZone } = this.state.eventData.date;

        if(moment(start) === null) return;

        const range = {...this.state.dateRange};

        // min date - now if event started or event start time if not
        range.end.minDate = this.state.eventStarted ? moment() : moment(start);
        // max date - start time + max hours of event
        range.end.maxDate = moment(start).tz(timeZone).add(REACT_APP_EVENT_MAX_DURATION_TIME_IN_HOURS, 'hours');
        // min time - this.minDate time (now or event start time)
        range.end.minTime = moment().tz(timeZone).hours(range.end.minDate.hours()).minutes(range.end.minDate.minutes());
        // max time - this.maxDate time (start time + limit hours)
        range.end.maxTime = moment().tz(timeZone).hours(range.end.maxDate.hours()).minutes(range.end.maxDate.minutes());

        // if (min day) != (max day) && (max date <= end date) show range untile end of the day
        if(range.end.maxTime <= range.end.minTime && range.end.minDate.date() !== range.end.maxDate.date()) {
            range.end.maxTime = moment().tz(timeZone).hours(23).minutes(59);
        }

        if(date && moment(date) !== null) {
            // if date day is not currnet day -> start time from 0:00 (and not from current time)
            if(moment(date).date() !== range.end.minDate.date()) {
                range.end.minTime = moment().tz(timeZone).hours(0).minute(0);
                range.end.maxTime = moment().tz(timeZone).hours(range.end.maxDate.hours()).minutes(range.end.maxDate.minutes());
            } 
        }

        this.setState({dateRange: range});
    }

    updateEndDateRangeOnFocus() {
        this.updateEndDateRange()

        const { start, end, timeZone } = this.state.eventData.date;
        if(moment(start) === null || moment(end) === null) return;
        
        // if end date (day) is not start date
        // and has end date
        if(moment(end).tz(timeZone).date() !== moment(start).tz(timeZone).date()) {
            if(!isNaN(moment(end).tz(timeZone).date())) {
                const range = {...this.state.dateRange};
    
                // start time from 0:00 and not from start time
                range.end.minTime = moment().tz(timeZone).hours(0).minute(0);
                range.end.maxTime = moment().tz(timeZone).hours(range.end.maxDate.hours()).minutes(range.end.maxDate.minutes());
                
                this.setState({dateRange: range});
            }
        } 
    }

    handleDateChange(endOrStart) {
        return (value) => {
            const obj = {...this.state.eventData};
            obj.date[endOrStart] = value;
            
            // clear end date if start is empty
            if(endOrStart === 'start') {
                obj.date.end = null;
            }

            this.setState({eventData: obj}, this.handleSubmit);
            this.updateEndDateRange();
        }
    }

    handleSubmit() {
        if(!this.state.eventFinised && this.validation()) {
            const { dispatch, events } = this.props;
            const data = {...this.state.eventData};
            data.date = {...this.state.eventData.date};

            if(this.state.eventStarted) data.date.start = events.list[events.currentEventID].date.start;

            dispatch(EventsActions.updateEvent(events.currentEventID, data));
        }
    }

    render() {
        const {eventData, dateRange, eventFinised, eventStarted} = this.state;
        const date = eventData.date;
        const isDemo = eventData.demo || false;
        const tz = date && date.timeZone;
        const start = date && date.start;
        const end = date && date.end;
        const convertToMoment = (date) => date ? moment(date).tz(tz) : null;

        return (
            <Box id="dateEventSettings" col="1">
                <BoxTitle icon="faClock">
                    זמן ותאריך
                </BoxTitle>
                <div className="explain">
                    <strong>שימו <FontAwesomeIcon icon={faHeart} /></strong>
                    <li>
                        כל הזמנים הם לפי שעון ישראל
                    </li>
                    <li>
                        לא ניתן לשנות את זמן התחלת האירוע לאחר תחילתו
                    </li>
                    <li>
                        לא ניתן לשנות את האירוע לאחר סיומו
                    </li>
                    <li>
                        זמן אירוע מקסימלי הוא: {REACT_APP_EVENT_MAX_DURATION_TIME_IN_HOURS} שעות
                    </li>
                </div>
                <div className="labelMe">
                    <div className="inputLabel">
                        זמן תחילת האירוע:&nbsp;
                    </div>
                    <DatePicker 
                        showTimeSelect
                        isClearable={!eventFinised && !eventStarted && !isDemo}
                        timeFormat="H:mm"
                        timeIntervals={Number(REACT_APP_DATE_PICKER_TIME_INTERVALSE)}
                        minTime={dateRange.start.minTime} 
                        maxTime={dateRange.start.maxTime} 
                        minDate={dateRange.start.minDate}
                        maxDate={dateRange.start.maxDate}
                        selected={convertToMoment(start) || null}
                        onChange={this.handleDateChange('start')}
                        onSelect={this.updateStartDateRange}
                        disabled={eventFinised || eventStarted || isDemo}
                        placeholderText="לחצו כאן על מנת לבחור תאריך ושעה"
                        dateFormat="LLL"
                        readOnly
                    />
                </div>
                <div className="labelMe">
                    <div className="inputLabel">
                        זמן סיום האירוע:&nbsp;
                    </div>

                    <DatePicker 
                        showTimeSelect
                        isClearable={!eventFinised && !isDemo}
                        timeFormat="H:mm"
                        timeIntervals={Number(REACT_APP_DATE_PICKER_TIME_INTERVALSE)}
                        minTime={dateRange.end.minTime}
                        maxTime={dateRange.end.maxTime}
                        includeDates={[moment(dateRange.end.minDate), moment(dateRange.end.maxDate)]}
                        disabled={!start || start.length === 0 || eventFinised || isDemo}
                        selected={convertToMoment(end) || null}
                        onChange={this.handleDateChange('end')}
                        onSelect={this.updateEndDateRange}
                        onFocus={this.updateEndDateRangeOnFocus.bind(this)}
                        placeholderText={!start || start.length === 0 ? "קודם בחרו זמן התחלה" : "לחצו כאן על מנת לבחור תאריך ושעה"}
                        dateFormat="LLL"
                        readOnly
                    />
                </div>
            </Box>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        events: state.eventsReducer
    }
}

const DateWithRedux = connect(mapStateToProps)(Date);

export {DateWithRedux as Date};


// WEBPACK FOOTER //
// ./src/components/EventPage/settings/event/Date.jsx